import { adminApiFetch } from './apiService';

export const governanceService = {
  // ==================== AI Wallet ====================

  getAiWallet: async () => {
    const response = await adminApiFetch('governance/ai_wallet');
    return response.json();
  },

  updateDailyBudget: async (limit) => {
    const response = await adminApiFetch('governance/ai_wallet/update_daily_budget', {
      method: 'POST',
      body: JSON.stringify({ daily_budget_limit: limit })
    });
    return response.json();
  },

  // ==================== AI Credit Purchases ====================

  getAiCreditPacks: async () => {
    const response = await adminApiFetch('governance/ai_credit_purchases/packs');
    return response.json();
  },

  purchaseAiCredits: async (packId, confirm = false) => {
    const response = await adminApiFetch('governance/ai_credit_purchases', {
      method: 'POST',
      body: JSON.stringify({
        pack_id: packId,
        confirm: confirm
      })
    });
    return response.json();
  },

  getAiCreditPurchaseHistory: async () => {
    const response = await adminApiFetch('governance/ai_credit_purchases');
    return response.json();
  },

  // ==================== Usage Records ====================

  getUsageRecords: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);

    const queryString = queryParams.toString();
    const url = queryString ? `governance/usage_records?${queryString}` : 'governance/usage_records';
    const response = await adminApiFetch(url);
    return response.json();
  },

  getUsageSummary: async () => {
    const response = await adminApiFetch('governance/usage_records/summary');
    return response.json();
  },

  // ==================== Payment Methods ====================

  getPaymentMethods: async () => {
    const response = await adminApiFetch('governance/payment_methods');
    return response.json();
  },

  getSdkToken: async (returnUrl = null, amount = 1) => {
    const response = await adminApiFetch('governance/payment_methods/sdk_token', {
      method: 'POST',
      body: JSON.stringify({
        return_url: returnUrl,
        amount: amount
      })
    });
    return response.json();
  },

  bindCard: async (sdkToken, setDefault = false) => {
    const response = await adminApiFetch('governance/payment_methods/bind_card', {
      method: 'POST',
      body: JSON.stringify({
        sdk_token: sdkToken,
        set_default: setDefault
      })
    });
    return response.json();
  },

  removePaymentMethod: async (id) => {
    const response = await adminApiFetch(`governance/payment_methods/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  setDefaultPaymentMethod: async (id) => {
    const response = await adminApiFetch(`governance/payment_methods/${id}/set_default`, {
      method: 'POST'
    });
    return response.json();
  },

  // ==================== Invoices ====================

  getInvoices: async () => {
    const response = await adminApiFetch('governance/invoices');
    return response.json();
  },

  getInvoice: async (id) => {
    const response = await adminApiFetch(`governance/invoices/${id}`);
    return response.json();
  },

  payInvoice: async (invoiceId) => {
    const response = await adminApiFetch(`governance/invoices/${invoiceId}/pay`, {
      method: 'POST'
    });
    return response.json();
  },

  cancelInvoice: async (invoiceId) => {
    const response = await adminApiFetch(`governance/invoices/${invoiceId}/cancel`, {
      method: 'POST'
    });
    return response.json();
  },

  // ==================== Billing Profile ====================

  getBillingProfile: async () => {
    const response = await adminApiFetch('governance/billing_profile');
    return response.json();
  },

  updateBillingProfile: async (data) => {
    const response = await adminApiFetch('governance/billing_profile', {
      method: 'PATCH',
      body: JSON.stringify({ billing_profile: data })
    });
    return response.json();
  }
};

export default governanceService;
